import React, { Component } from 'react';
import axios from "axios";
import {appConfig} from "./../../tools/AppConfig";
import Waiting from './../waiting';
import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import Select from 'react-validation/build/select';
import Button from 'react-validation/build/button';
import './../../custom.css';
import './../../pages/invoice.css';
import visaImg from './../../../statics/img/visa.svg';
import creditImg from './../../../statics/img/credit.svg';
import AAIBLogoImg from './../../../statics/img/AAIB-logo.png';
import acceptBlueImg from './../../../statics/img/accept_blue.png';
import symplImg from './../../../statics/img/payment_methods_logos/Sympl.png';
import validator from 'validator';
import './sympl.css';

const required = (value) => {
  if (!value.toString().trim().length) {
    // We can return string or jsx as the 'error' prop for the validated Component
    return <div className="alert alert-danger fieldErrorMessage" role="alert"><i className="fa fa-exclamation-circle"></i> This field is required.</div>;
  }
};
const CreditCard = (value) => {
    let regex = new RegExp("^[0-9]{16}$");
    if (!regex.test(value)) {
        return <div className="alert alert-danger fieldErrorMessage" role="alert"><i className="fa fa-exclamation-circle"></i> Please enter a valid card number.</div>;
    };
}
const Cvv = (value) => {
    if(!validator.isNumeric(value) || value.toString().trim().length < 3 || value.toString().trim().length > 4 ){
        return <div className="alert alert-danger fieldErrorMessage" role="alert"><i className="fa fa-exclamation-circle"></i> Please enter valid CVV.</div>;
    }
};
const FullName = (value) => {
    var patt = new RegExp("[a-zA-Z]+ [a-zA-Z]+");
    if(!patt.test(value)){
        return <div className="alert alert-danger fieldErrorMessage" role="alert"><i className="fa fa-exclamation-circle"></i> Please enter valid card holder name.</div>;
    }
};
const PhoneNumber = (value) => {
    if(!validator.isNumeric(value) || value.toString().trim().length > 14 || value.toString().trim().length < 8 ){
        return <div className="alert alert-danger fieldErrorMessage" role="alert"><i className="fa fa-exclamation-circle"></i> Please enter valid Phone number.</div>;
    }
};

const NationalId= (value) => {
    if(!validator.isNumeric(value) || value.toString().trim().length != 14){
        return <div className="alert alert-danger fieldErrorMessage" role="alert"><i className="fa fa-exclamation-circle"></i> Please enter valid National ID.</div>;
    }
};

class card extends Component {
      constructor(props) {
        super(props);
        this.state = {
            waiting: false,
            userData: props.userData,
            deliveryNeed: props.deliveryNeed,
            deliveryData: props.deliveryData,
            cardNumber: '',
            cardHolderName: '',
            expiryMonth: '',
            expiryYear: '',
            cvv: '',
            last_sympl_card:{
                month: "",
                year: "",
                card: ""
            },
            card_form_not_start: true,
            current_step: 1,
            valid_sympl: false,
            sympl_plans_data:{},
            main_selected_plan: 0,
            sub_selected_plan: -1,
            terms: [false, false, false],
            phone_number: "",
            down_payment: 0,
            disable_down_payment: true,
            min_down_payment: 0,
            max_down_payment: 0,
            sympl_backend_err_msg: "",
            //step2 
            step2_error: false,
            step2_error_message: "",
            mobile_number: "",
            national_id: "",
            //step3
            step3_waiting: false,
            down_waiting: false,
            gif_waiting: false,
            promo_step: 1,
            promo_state: "",
            promo_code: "",
            promo_data: {},
            //step3
            step4_waiting: false,
            step4_error: false,
            otp: ""
        };
        this.getFirstName = this.getFirstName.bind(this);
        this.getLastName = this.getLastName.bind(this);
        this.handleCardNumChange = this.handleCardNumChange.bind(this);
        this.handleCardNumValueChange = this.handleCardNumValueChange.bind(this);
        this.handelCardHolderName = this.handelCardHolderName.bind(this);
        this.handelCardHolderNameValue = this.handelCardHolderNameValue.bind(this);
        this.handelExpiryMonthChange = this.handelExpiryMonthChange.bind(this);
        this.handelExpiryYearChange = this.handelExpiryYearChange.bind(this);
        this.handelCVVChange = this.handelCVVChange.bind(this);
        this.handelCVVValueChange = this.handelCVVValueChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
      }
    down_payment_validation = (value) => {
        if(!validator.isNumeric(value.toString()) || this.state.down_payment <  this.state.min_down_payment || this.state.down_payment >  this.state.max_down_payment){
            return <div className="alert alert-danger fieldErrorMessage" role="alert"><i className="fa fa-exclamation-circle"></i> Down payment must be in range ({this.state.min_down_payment} - {this.state.max_down_payment})</div>;
        }
    };
    getFirstName(fullName) {
        var namesArr = fullName.split(" ");
        return namesArr[0]
    }
    getLastName(fullName) {
        var namesArr = fullName.split(" ");
        return namesArr[namesArr.length - 1];
    }
    handleCardNumChange(e) {
        this.setState({cardNumber: e.target.value},()=>{
            this.check_sympl()
        });
    }
    handleCardNumValueChange(value) {
        this.setState({cardNumber: value});
    }
    handelCardHolderName(e) {
        this.setState({cardHolderName: e.target.value});
    }
    handelCardHolderNameValue(value) {
        this.setState({cardHolderName: value});
    }
    handelExpiryMonthChange(e) {
        this.setState({expiryMonth: e.target.value},()=>{
            this.check_sympl()
        });
    }
    handelExpiryYearChange(e) {
        this.setState({expiryYear: e.target.value},()=>{
            this.check_sympl()
        });
    }
    handelCVVChange(e) {
        this.setState({cvv: e.target.value});
    }
    handelCVVValueChange(value) {
        this.setState({cvv: value});
    }
    handleSubmit(event) {
        //start waiting
        this.setState({waiting: true});
        //disable payment method options
        this.props.disableAllPaymentMethods();
        //post req
        let url;
        if(this.props.sourcePage ==='invoice'){
            url = appConfig.getServerUrl() + '/invoice2/'+ this.state.userData.token;
        }else if(this.props.sourcePage ==='product'){
            url = appConfig.getServerUrl() + '/product2/'+ this.state.userData.token;
        }
        let paymentDict;
        if(this.props.sourcePage ==='invoice'){
            paymentDict = {
                "source": {
                    "identifier": this.state.cardNumber,
                    "sourceholder_name": this.state.cardHolderName,
                    "expiry_month": this.state.expiryMonth,
                    "expiry_year": this.state.expiryYear,
                    "cvn": this.state.cvv,
                    "down_payment": this.state.down_payment,
                    "tenure": this.state.sympl_plans_data.paymentPlans[this.state.main_selected_plan].tenure.paymentsCount,
                    "selected_plan": this.state.sympl_plans_data.paymentPlans[this.state.main_selected_plan].paymentsWithDates[this.state.sub_selected_plan].period,
                    "mobile_number": this.state.phone_number,
                    "subtype": "SYMPL"
                }, "shipping_data": {
                    'apartment': "",
                    'email': this.state.userData.order_email,
                    'floor': "",
                    'first_name': this.getFirstName(this.state.userData.order_full_name),
                    'street': "",
                    'building': "",
                    'phone_number': this.state.userData.order_phone,
                    'postal_code': "",
                    'city': "",
                    'country': "",
                    'last_name': this.getLastName(this.state.userData.order_full_name),
                    'state': "",
                    'extra_description': ''
                },
                "token": this.state.userData.token,
                "integration_id": this.state.userData.integration_ids.SYMPL
            };
            if(this.state.deliveryNeed){
                paymentDict.shipping_data.country = this.state.deliveryData.country;
                paymentDict.shipping_data.state = this.state.deliveryData.state;
                paymentDict.shipping_data.city = this.state.deliveryData.city;
                paymentDict.shipping_data.building = this.state.deliveryData.building;
                paymentDict.shipping_data.street = this.state.deliveryData.street;
                paymentDict.shipping_data.floor = this.state.deliveryData.floor;
                paymentDict.shipping_data.apartment = this.state.deliveryData.apartment;
                paymentDict.shipping_data.postal_code = this.state.deliveryData.postal_code;
                paymentDict.shipping_data.extra_description = this.state.deliveryData.notes;
            }
        }else if(this.props.sourcePage ==='product'){
            paymentDict = {
                "order_data": {
                    "delivery_needed": this.state.deliveryNeed,
                    "amount_cents": this.state.userData.amount * this.props.quantity * 100,
                    "currency": this.state.userData.currency,
                    "shipping_data": {
                        "first_name": this.getFirstName(this.state.deliveryData.name),
                        "last_name": this.getLastName(this.state.deliveryData.name),
                        "phone_number": this.state.deliveryData.phone,
                        "email": this.state.deliveryData.email,
                        "street": 'NA',
                        "city": 'NA',
                        "country": 'NA',
                        "postal_code": 'NA',
                        "state": "NA"
                    },
                    "items": [{
                        "name": this.state.userData.product.product_name,
                        "amount_cents": this.state.userData.amount * 100,
                        "quantity": this.props.quantity,
                    }]
                },
                "source": {
                    "identifier" : this.state.cardNumber,
                    "sourceholder_name" : this.state.cardHolderName,
                    "expiry_month" : this.state.expiryMonth,
                    "expiry_year" : this.state.expiryYear,
                    "cvn" : this.state.cvv,
                    "down_payment": this.state.down_payment,
                    "tenure": this.state.sympl_plans_data.paymentPlans[this.state.main_selected_plan].tenure.paymentsCount,
                    "selected_plan": this.state.sympl_plans_data.paymentPlans[this.state.main_selected_plan].paymentsWithDates[this.state.sub_selected_plan].period,
                    "mobile_number": this.state.phone_number,
                    "subtype": "SYMPL"
                },
                "token": this.state.userData.token,
                "integration_id": this.state.userData.integrations.SYMPL,
            };
            if(this.state.deliveryNeed){
                paymentDict.order_data.shipping_data.country = this.state.deliveryData.country;
                paymentDict.order_data.shipping_data.state = this.state.deliveryData.state;
                paymentDict.order_data.shipping_data.city = this.state.deliveryData.city;
                paymentDict.order_data.shipping_data.building = this.state.deliveryData.building;
                paymentDict.order_data.shipping_data.street = this.state.deliveryData.street;
                paymentDict.order_data.shipping_data.floor = this.state.deliveryData.floor;
                paymentDict.order_data.shipping_data.apartment = this.state.deliveryData.apartment;
                paymentDict.order_data.shipping_data.postal_code = this.state.deliveryData.postal_code;
                paymentDict.order_data.shipping_data.extra_description = this.state.deliveryData.notes;
            }
        }
        
        
        let jsonPaymentDict = JSON.stringify(paymentDict);
        let config = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        axios.post(url, jsonPaymentDict, config)
        .then((resp) => {
            //enable payment methods
            this.props.enableAllPaymentMethods();
            //show result
            if(resp.data.success === true){
                if (resp.data.url) {
                    window.location.href = resp.data.url;
                }else {
                    //stop waiting
                    this.setState({waiting: false});
                    this.props.setReqComplete({head: 'Transaction successful', body:'Thank you for using the online payment service.'});
                    //this.props.setReqComplete({sympl: true, sympl_data: {}});
                }
            }else{
                //succes = false
                this.props.setReqComplete({head: 'Transaction declined', body:'Please try again later. If this problem persists, please contact your service provider.'});
            }
        })
        .catch((err) => {
            //stop waiting
            this.setState({waiting: false});
            //enable payment methods
            this.props.enableAllPaymentMethods();
            if(err.response.status === 404){
                alert('Please check your internet connection and try again.');
            }
        });
        event.preventDefault();
    }
    check_sympl_req_no_phone = () => {
        this.setState({inner_waiting: true, sympl_backend_err_msg: "", card_form_not_start: false}, () => {
            let url = appConfig.getServerUrl() + '/api/auth/bank-installments/sympl';
            let sympl_data = {
                "card_pin": this.state.last_sympl_card.card,
                "card_expiry": this.state.last_sympl_card.month + this.state.last_sympl_card.year,
                "payment_token": this.state.userData.sympl_payment_key
            }
            if(this.state.current_step == 2){
                sympl_data["mobile_number"] = this.state.mobile_number;
                sympl_data["national_id"] = this.state.national_id;
            }
            
            
            let json_sympl_data = JSON.stringify(sympl_data);
            let config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                }
            };
            axios.post(url, json_sympl_data, config)
            .then((resp) => {
                if(resp.data.httpStatus == 400){
                    if(resp.data && resp.data.params && resp.data.params.length != 0 && resp.data.params[0].txnRequestedAmount){
                        this.setState({valid_sympl: false, inner_waiting: false, sympl_backend_err_msg: resp.data.params[0].txnRequestedAmount})
                    }else{
                        this.setState({valid_sympl: false, inner_waiting: false})
                    }
                }else{
                    this.setState({
                        inner_waiting: false,
                        valid_sympl: true, 
                        sympl_plans_data: resp.data, 
                        disableAllPaymentMethods: true, 
                        down_payment: resp.data.customerTxnPayment.downPayment,
                        min_down_payment: resp.data.customerTxnPayment.downPayment,
                        max_down_payment: resp.data.metaData.maxAllowedDownPayment
                    })
                }
            })
            .catch((err) => {
                if(err.data && err.data.params && err.data.params.length != 0 && err.data.params[0].txnRequestedAmount){
                    this.setState({valid_sympl: false, inner_waiting: false, sympl_backend_err_msg: err.data.params[0].txnRequestedAmount})
                }else{
                    this.setState({valid_sympl: false, inner_waiting: false})
                }
            });
        })
    }
    re_check_sympl_req_dwon_payment = (e) => {
        e.preventDefault();
        this.setState({down_waiting: true}, () => {
            let url = appConfig.getServerUrl() + '/api/auth/bank-installments/sympl';
            let sympl_data = {
                "mobile_number": this.state.mobile_number,
                "national_id": this.state.national_id,
                "card_pin": this.state.last_sympl_card.card,
                "card_expiry": this.state.last_sympl_card.month + this.state.last_sympl_card.year,
                "payment_token": this.state.userData.sympl_payment_key,
                "down_payment": this.state.down_payment
            }
            if(this.state.promo_step == 3 && this.state.promo_state == "success"){
                sympl_data["promo_code"] = this.state.promo_code
            }
            
            let json_sympl_data = JSON.stringify(sympl_data);
            let config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                }
            };
            axios.post(url, json_sympl_data, config)
            .then((resp) => {
                if(resp.data.httpStatus == 400){
                    if(resp.data && resp.data.params && resp.data.params.length != 0 && resp.data.params[0].txnRequestedAmount){
                        this.setState({valid_sympl: false, down_waiting: false, sympl_backend_err_msg: resp.data.params[0].txnRequestedAmount})
                    }else{
                        this.setState({valid_sympl: false, down_waiting: false})
                    }
                }else{
                    this.setState({
                        down_waiting: false,
                        valid_sympl: true, 
                        sympl_plans_data: resp.data, 
                        disableAllPaymentMethods: true, 
                        down_payment: resp.data.customerTxnPayment.downPayment,
                        min_down_payment: resp.data.customerTxnPayment.downPayment,
                        max_down_payment: resp.data.metaData.maxAllowedDownPayment
                    })
                }
            })
            .catch((err) => {
                if(err.data && err.data.params && err.data.params.length != 0 && err.data.params[0].txnRequestedAmount){
                    this.setState({valid_sympl: false, down_waiting: false, sympl_backend_err_msg: err.data.params[0].txnRequestedAmount})
                }else{
                    this.setState({valid_sympl: false, down_waiting: false})
                }
            });
        })
    }
    check_sympl = () => {
        //this.props.setReqComplete({head: 'Transaction successful', body:'Thank you for using the online payment service.'});
        //this.props.setReqComplete({sympl: true, sympl_data: {}});
        if(this.state.cardNumber.length >= 16 && this.state.expiryMonth != "" && this.state.expiryYear != ""){
            if(
                this.state.expiryMonth != this.state.last_sympl_card.month || 
                this.state.expiryYear != this.state.last_sympl_card.year || 
                this.state.cardNumber.slice(0, 16) != this.state.last_sympl_card.card.slice(0, 16)
            ){
                //set new data
                let last_sympl_card = {...this.state.last_sympl_card}
                last_sympl_card.month = this.state.expiryMonth;
                last_sympl_card.year = this.state.expiryYear;
                last_sympl_card.card = this.state.cardNumber;
                this.setState({last_sympl_card: last_sympl_card}, ()=>{
                    this.check_sympl_req_no_phone();
                })
            }
        }else{
            //set new data
            let last_sympl_card = {...this.state.last_sympl_card}
            last_sympl_card.month = this.state.expiryMonth;
            last_sympl_card.year = this.state.expiryYear;
            last_sympl_card.card = this.state.cardNumber;
            this.setState({last_sympl_card: last_sympl_card, current_step: 1})
        }
    }
    main_plan_change = (index) => {
        this.setState({main_selected_plan: index, sub_selected_plan: -1})
    }
    sub_plan_change = (index) => {
        this.setState({sub_selected_plan: index})
    }
    render_circle = (num, width) => {
        let final_num = parseInt(num * 360);
        let arr = [];
        for(let x = 0; x < 360; x++){
            if(x <= final_num){arr.push(true);}else{arr.push(false);}
        }
        let final_circle = 
            <svg height={width} width={width} class="custom_circle">
                {arr.map((ele, index)=>{
                    let x = (width/2) + (width/2) * Math.cos(index * (Math.PI/180));
                    let y = (width/2) + (width/2) * Math.sin(index * (Math.PI/180));
                    return ele ? 
                        <line key={index} className="active" x1={(width/2)} y1={(width/2)} x2={x} y2={y} style={{stroke_width:1}} />
                    :
                        <line key={index} x1={(width/2)} y1={(width/2)} x2={x} y2={y} style={{stroke_width:1}} />
                })}
                Sorry, your browser does not support inline SVG.
            </svg>;
            return final_circle;
                                    
    }
    handle_terms = (index) => {
        let terms = this.state.terms;
        if(terms[index]){
            terms[index] = false;
            this.setState({terms: terms})
        }else{
            this.setState({terms: [true, true, true]})
        }
    }
    handle_phone_number = (e) => {
        this.setState({phone_number: e.target.value});
    }
    handle_down_payment = (e) => {
        this.setState({down_payment: e.target.value});
    }
    handle_promo_code = (e) => {
        this.setState({promo_code: e.target.value});
    }
    handle_edit_down_payment = (e) => {
        e.preventDefault();
        if(this.state.disable_down_payment){
            this.setState({disable_down_payment: false})
        }else{
            this.setState({disable_down_payment: true, inner_waiting: true, sympl_backend_err_msg: ""}, () => {
                this.re_check_sympl_req_dwon_payment(e)
            })
        }
    }
    handle_apply_promo = (e) => {
        e.preventDefault();
        this.setState({gif_waiting: true}, () => {
            let url = appConfig.getServerUrl() + '/api/auth/bank-installments/sympl';
            let sympl_data = {
                "card_pin": this.state.last_sympl_card.card,
                "mobile_number": this.state.mobile_number,
                "national_id": this.state.national_id,
                "card_expiry": this.state.last_sympl_card.month + this.state.last_sympl_card.year,
                "payment_token": this.state.userData.sympl_payment_key,
                "down_payment": this.state.down_payment
            }
            if(this.state.promo_code != ""){
                sympl_data["promo_code"] = this.state.promo_code
            }
            
            let json_sympl_data = JSON.stringify(sympl_data);
            let config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                }
            };
            axios.post(url, json_sympl_data, config)
            .then((resp) => {
                if(resp.data.httpStatus == 400){
                    this.setState({promo_step: 3, promo_state: "fail", gif_waiting: false})
                }else{
                    this.setState({
                        gif_waiting: false,
                        promo_step: 3,
                        promo_state: "success",
                        promo_data: resp.data.customerTxnPayment,
                        sympl_plans_data: resp.data, 
                        disableAllPaymentMethods: true, 
                        down_payment: resp.data.customerTxnPayment.downPayment,
                        min_down_payment: resp.data.customerTxnPayment.downPayment,
                        max_down_payment: resp.data.metaData.maxAllowedDownPayment
                    })
                }
            })
            .catch((err) => {
                this.setState({promo_step: 3, promo_state: "fail", gif_waiting: false})
            });
        })
    }
    render_sympl = () => {
            return(
                <Form onSubmit={this.request_otp}>
                    <div className="sympl_container">
                        <div>
                            <div className="installmentsDiv" id="installmentContainer_sympl">
                                <div className={this.state.step3_waiting || this.state.current_step > 3 ? "installmentsHead step3_waiting" : "installmentsHead"}>
                                    <div className="step3_cover"></div>
                                    <div className="step3_body">
                                        <div className="prev_info">
                                            <p><span>Mobile Number</span>{this.state.mobile_number}</p>
                                            <p><span>National ID no.</span>{this.state.national_id}</p>
                                        </div>
                                        <p className="total_amount"> Total Amount  
                                            {this.state.promo_step == 3 && this.state.promo_state == "success" ?
                                                <> <del> {this.state.promo_data.financedTxnAmount}</del> <span>{this.state.promo_data.finalTxnAmount}</span></>
                                            :
                                                <span> {this.state.sympl_plans_data.customerTxnPayment.financedTxnAmount}</span>
                                            }
                                        </p>
                                            <>
                                                <div className="downPayment">
                                                    {this.state.promo_step == 1 &&
                                                        <>
                                                            <button className="sympl_btn" onClick={() => {this.setState({promo_step: 2})}}>Apply Promo Code</button>
                                                        </>
                                                    }
                                                    {this.state.promo_step == 2 &&
                                                        <>
                                                            <div className="div_1">
                                                                <p>Promo code</p>
                                                            </div>
                                                            <div className="div_2">
                                                                <div className="newInput">
                                                                    <Input type="text" 
                                                                        name="promo_code" 
                                                                        disabled={this.state.gif_waiting}
                                                                        value={this.state.promo_code}
                                                                        onChange={this.handle_promo_code}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="div_3">
                                                                {this.state.promo_code != "" ?
                                                                    <button className="sympl_btn" onClick={this.handle_apply_promo}>{this.state.gif_waiting ? <i className="fa fa-spinner fa-spin"/> : "Apply"}</button>
                                                                :
                                                                    <button className="sympl_btn" disabled={true}>Apply</button>
                                                                }
                                                                
                                                            </div>
                                                        </>
                                                    }
                                                    {this.state.promo_step == 3 &&
                                                        <>
                                                            {this.state.promo_state == "success" ?
                                                                <div className="promo_success">
                                                                    <span className="promo_success_span"><i className="fa fa-gift" /> EGP {this.state.promo_data.discountDetails.amount} off</span>
                                                                </div>
                                                            :
                                                                <div className="promo_fail">
                                                                    <span className="promo_error_span"><i className="fa fa-times-circle" /> Sorry!, Invalid promo code</span>
                                                                    <button className="sympl_btn" onClick={() => {this.setState({promo_step: 2})}}>Try again</button>
                                                                </div>
                                                            }
                                                        </>
                                                    }
                                                </div>
                                                <div className="downPayment">
                                                    <div className="div_1">
                                                        <p>Down payment</p>
                                                        <span>(Will be deducted from your card now)</span>
                                                    </div>
                                                    <div className="div_2">
                                                        <div className="newInput">
                                                            <Input type="number" 
                                                            name="down_payment" 
                                                            placeholder={this.state.down_payment}
                                                            disabled={(this.state.disable_down_payment || this.state.down_waiting)}
                                                            value={this.state.down_payment}
                                                            onChange={this.handle_down_payment}
                                                            validations={[required, this.down_payment_validation]} 
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="div_3">
                                                        {this.state.down_payment >= this.state.min_down_payment && this.state.down_payment <= this.state.max_down_payment ?
                                                            <button className="sympl_btn" onClick={this.handle_edit_down_payment}>{this.state.down_waiting ? <i className="fa fa-spinner fa-spin"/> : (this.state.disable_down_payment ? "Edit" : "Submit")}</button>
                                                        :
                                                            <button className="sympl_btn" disabled={true}>{this.state.disable_down_payment ? "Edit" : "Submit"}</button>
                                                        }
                                                        
                                                    </div>
                                                </div>
                                            </>
                                        <div className="sympl_main_plans">
                                            {this.state.sympl_plans_data.paymentPlans.map((plan, index)=>{
                                                return(
                                                    <div key={index} className={this.state.main_selected_plan == index ? "active" : ""} onClick={()=>{this.main_plan_change(index)}}>
                                                        <p>{plan.tenure.singlePaymentAmount}</p>
                                                        <span>On {plan.tenure.paymentsCount} payments</span>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                        <div className="current_plan_details">
                                            <p>Choose your payment plan</p>
                                            {this.state.sympl_plans_data.paymentPlans[this.state.main_selected_plan].paymentsWithDates.map((sub_plan, index)=>{
                                                return(
                                                    <div key={"sub_" + index} className="sub_plan_details">
                                                        <p>{this.state.sympl_plans_data.paymentPlans[this.state.main_selected_plan].tenure.singlePaymentAmount} {sub_plan.period}</p>
                                                        <div className={this.state.sub_selected_plan == index ? "active" : ""} onClick={()=>{this.sub_plan_change(index)}}>
                                                            {sub_plan.payments.map((payment, payment_index) => {
                                                                return(
                                                                    <span>
                                                                        {this.render_circle((payment_index+1)/sub_plan.payments.length, 25)}
                                                                        <span>{payment}</span>
                                                                    </span>
                                                                )
                                                            })}
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                        <div className="sympl_footer">
                                            <div className="fees_div">
                                                <p>One-time service fee <i>(will be deducted from your card now)</i> </p>
                                                <span>{this.state.sympl_plans_data.customerTxnPayment.fees}</span>
                                                
                                            </div>
                                            <div className="accept_condition">
                                                <input type="checkbox" name="check_accept_plans" className="checking" checked={this.state.terms[0]} onClick={()=>{this.handle_terms(0)}}/>
                                                <p>I accept deduction of my payment plan, down payment, and service fee from my card</p>
                                            </div>
                                            <div className="accept_condition">
                                                <input type="checkbox" name="check_accept_refund" className="checking" checked={this.state.terms[1]} onClick={()=>{this.handle_terms(1)}}/>
                                                <p>I agree that incase of refund,Sympl service fee cannot be refunded after 72 hours from the purchase date. I hereby agree to Sympl <a href="#"><i>refund policy</i></a></p>
                                            </div>
                                            <div className="accept_condition">
                                                <input type="checkbox" name="check_accept_terms" className="checking" checked={this.state.terms[2]} onClick={()=>{this.handle_terms(2)}}/>
                                                <p>I accept Sympl <a href="#"><i>Terms & Conditions</i></a></p>
                                            </div>
                                            <div className="submit">

                                                
                                                {this.state.step3_waiting ?
                                                    <button disabled={true} className="confirmBtnNew"><i className="fa fa-spinner fa-spin" /></button>
                                                :
                                                    <>
                                                        {this.state.terms[0] && this.state.terms[1] &&this.state.terms[2] && this.state.sub_selected_plan != -1 ?
                                                            <Button className="confirmBtnNew">Confirm & Send OTP</Button>
                                                        :
                                                            <button disabled={true} className="confirmBtnNew">Confirm & Send OTP</button>
                                                        }
                                                    </>
                                                }
                                                {/* {this.state.terms[0] && this.state.terms[1] &&this.state.terms[2] && this.state.sub_selected_plan != -1 ?
                                                    <Button className="confirmBtnNew">PAY {this.state.sympl_plans_data.customerTxnPayment.downPayment + this.state.sympl_plans_data.customerTxnPayment.fees} NOW</Button>
                                                :
                                                    <button disabled={true} className="confirmBtnNew">PAY {this.state.sympl_plans_data.customerTxnPayment.downPayment + this.state.sympl_plans_data.customerTxnPayment.fees} NOW</button>
                                                } */}
                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Form>
            )
    }
    check_sympl_req_step_2 = (e) => {
        e.preventDefault();
        this.setState({inner_waiting: true, sympl_backend_err_msg: ""}, () => {
            let url = appConfig.getServerUrl() + '/api/auth/bank-installments/sympl';
            let sympl_data = {
                "mobile_number": this.state.mobile_number,
                "national_id": this.state.national_id,
                "card_pin": this.state.last_sympl_card.card,
                "card_expiry": this.state.last_sympl_card.month + this.state.last_sympl_card.year,
                "payment_token": this.state.userData.sympl_payment_key
            }
            let json_sympl_data = JSON.stringify(sympl_data);
            let config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                }
            };
            axios.post(url, json_sympl_data, config)
            .then((resp) => {
                if(resp.data.httpStatus == 400){
                    this.setState({step2_error: true, inner_waiting: false, step2_error_message: "Wrong phone number or national ID"})
                }else{
                    this.setState({
                        inner_waiting: false,
                        current_step: 3,
                        sympl_plans_data: resp.data, 
                        disableAllPaymentMethods: true, 
                        down_payment: resp.data.customerTxnPayment.downPayment,
                        min_down_payment: resp.data.customerTxnPayment.downPayment,
                        max_down_payment: resp.data.metaData.maxAllowedDownPayment
                    })
                }
            })
            .catch((err) => {
                this.setState({step2_error: true, inner_waiting: false, step2_error_message: "Wrong phone number or national ID"})
            });
        })
    }
    request_otp = (e) => {
        e.preventDefault();
        this.setState({step3_waiting: true}, () => {
            let url = appConfig.getServerUrl() + '/api/auth/bank-installments/sympl';
            let sympl_data = {
                "mobile_number": this.state.mobile_number,
                "national_id": this.state.national_id,
				"down_payment": Number(this.state.down_payment),
                "card_pin": this.state.last_sympl_card.card,
                "card_expiry": this.state.last_sympl_card.month + this.state.last_sympl_card.year,
                "payment_token": this.state.userData.sympl_payment_key,
                "request_otp": true
            }
            if(this.state.promo_step == 3 && this.state.promo_state == "success"){
                sympl_data["promo_code"] = this.state.promo_code
            }
            let json_sympl_data = JSON.stringify(sympl_data);
            let config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                }
            };
            axios.post(url, json_sympl_data, config)
            .then((resp) => {
                if(resp.data.httpStatus == 400){
                    this.setState({step3_waiting: false})
                }else{
                    this.setState({
                        step3_waiting: false,
                        current_step: 4
                    })
                }
            })
            .catch((err) => {
                this.setState({step3_waiting: false})
            });
        })
    }
    change_mobile_number = (e) => {
        this.setState({mobile_number: e.target.value, step2_error: false, step2_error_message: ""})
    }
    change_national_id = (e) => {
        this.setState({national_id: e.target.value, step2_error: false, step2_error_message: ""})
    }
    change_step = (step) => {
        this.setState({current_step: step})
    }
    render_card_form = () => {
        return(
            <Form onSubmit={()=>{this.change_step(2)}}>
                <div className="row">
                    <div className="col-md-6 col-sm-12 col-xs-12">
                        <div className="newInput">
                            <Input type="number" 
                            pattern="[0-9]*"
                            name="c_pan_U" 
                            placeholder="Card Number"
                            value={this.state.cardNumber} 
                            onChange={(e) => {e.target.value.length <= 16 ?  this.handleCardNumChange(e) : this.handleCardNumValueChange(e.target.value.slice(0, 16))}}
                            validations={[required,CreditCard]} 
                            />
                            <span className="visaIcon">
                                    <img src={creditImg}/>
                                    <img src={visaImg}/>
                            </span>
                        </div>
                    </div>
                    <div className="col-md-6 col-sm-12 col-xs-12">
                        <div className="newInput">
                            <Input type="text" 
                            name="c_holder_name_U" 
                            placeholder="Card Holder Name"
                            value={this.state.cardHolderName}
                            onChange={this.handelCardHolderName}
                            onChange={(e) => {/^[a-zA-Z\s]+$/.test(e.target.value)?  this.handelCardHolderName(e) : this.handelCardHolderNameValue(e.target.value.slice(0, e.target.value.length - 1))}}
                            validations={[required]} 
                            />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4 col-sm-12 col-xs-12">
                        <div className="newInput">
                            <Select 
                            id="cardExMM" 
                            name="c_expiry_mm_U" 
                            required 
                            value={this.state.expiryMonth}
                            onChange={this.handelExpiryMonthChange}
                            validations={[required]} 
                            >
                                <option value="" disabled>MM</option>
                                <option value="01">01</option>
                                <option value="02">02</option>
                                <option value="03">03</option>
                                <option value="04">04</option>
                                <option value="05">05</option>
                                <option value="06">06</option>
                                <option value="07">07</option>
                                <option value="08">08</option>
                                <option value="09">09</option>
                                <option value="10">10</option>
                                <option value="11">11</option>
                                <option value="12">12</option>
                            </Select>
                        </div>
                    </div>
                    <div className="col-md-4 col-sm-12 col-xs-12">
                        <div className="newInput">
                            <Select 
                            id="cardExYY" 
                            name="c_expiry_yy_U"  
                            required
                            value={this.state.expiryYear}
                            onChange={this.handelExpiryYearChange}
                            validations={[required]} 
                            >
                                <option value="" disabled>YY</option>
                                <option value="21">2021</option>
                                <option value="22">2022</option>
                                <option value="23">2023</option>
                                <option value="24">2024</option>
                                    <option value="25">2025</option>
                                    <option value="26">2026</option>
                                    <option value="27">2027</option>
                                    <option value="28">2028</option>
                                    <option value="29">2029</option>
                                    <option value="30">2030</option>
                            </Select>
                        </div>
                    </div>
                    <div className="col-md-4 col-sm-12 col-xs-12">
                        <div className="newInput">
                            <Input type="number" 
                            pattern="[0-9]*" 
                            id="cardCVV" 
                            name="c_cvv_U" 
                            placeholder="CVV" 
                            required 
                            value={this.state.cvv}
                            onChange={(e) => {e.target.value.length <= 4 ?  this.handelCVVChange(e) : this.handelCVVValueChange(e.target.value.slice(0, 4))}}
                            validations={[required, Cvv]} 
                            />
                        </div>
                    </div>
                </div>
                {this.state.inner_waiting ?
                    <Waiting height='150px' />
                :
                    this.state.valid_sympl || this.state.card_form_not_start  ?
                        <div className="submit_div">
                            {this.state.valid_sympl ?
                                <Button className="confirmBtnNew">Next</Button>
                            :
                                <button disabled={true} className="confirmBtnNew">Next</button>
                            }
                        </div>
                    :
                        <div>
                            <br/>
                            {this.state.sympl_backend_err_msg == "" ?
                                <p className="sy_no_text">Your card is Not eligible for 0% interest pay later plans, please contact your bank</p>
                            :
                                <p className="sy_no_text">{this.state.sympl_backend_err_msg}</p>
                            }
                        </div>
                }
            </Form>
        )
    }
    render_phone_national_form = () => {
        return(
            <Form onSubmit={this.check_sympl_req_step_2}>
                <div className="row">
                    <div className="col-md-6 col-sm-12 col-xs-12">
                        <div className="newInput">
                            <Input type="number" 
                                pattern="[0-9]*"
                                name="mobile_number" 
                                placeholder="Phone Number"
                                value={this.state.mobile_number} 
                                onChange={this.change_mobile_number}
                                validations={[required,PhoneNumber]} 
                            />
                        </div>
                    </div>
                    <div className="col-md-6 col-sm-12 col-xs-12">
                        <div className="newInput">
                            <Input type="number" 
                                pattern="[0-9]*"
                                name="national_id" 
                                placeholder="National ID"
                                value={this.state.national_id} 
                                onChange={this.change_national_id}
                                validations={[required,NationalId]} 
                            />
                        </div>
                    </div>
                </div>
                {this.state.inner_waiting ?
                    <Waiting height='150px' />
                :
                    <div className="submit_div">
                        {!this.state.step2_error ?
                            <Button className="confirmBtnNew">Next</Button>
                        :
                            <>
                                <div className="alert alert-danger">{this.state.step2_error_message}</div>
                                <button disabled={true} className="confirmBtnNew">Next</button>
                            </>
                        }
                    </div>
                }
            </Form>
        )
    }
    change_otp = (e) => {
        this.setState({otp: e.target.value, step4_error: false})
    }
    final_submit = (e) => {
        e.preventDefault();
        this.setState({step4_waiting: true}, ()=>{
            //disable payment method options
            this.props.disableAllPaymentMethods();
            //post req
            let url;
            if(this.props.sourcePage ==='invoice'){
                url = appConfig.getServerUrl() + '/invoice2/'+ this.state.userData.token;
            }else if(this.props.sourcePage ==='product'){
                url = appConfig.getServerUrl() + '/product2/'+ this.state.userData.token;
            }
            let paymentDict;
            if(this.props.sourcePage ==='invoice'){
                paymentDict = {
                    "source": {
                        "identifier": this.state.cardNumber,
                        "sourceholder_name": this.state.cardHolderName,
                        "expiry_month": this.state.expiryMonth,
                        "expiry_year": this.state.expiryYear,
                        "cvn": this.state.cvv,
                        "tenure": this.state.sympl_plans_data.paymentPlans[this.state.main_selected_plan].tenure.paymentsCount,
                        "selected_plan": this.state.sympl_plans_data.paymentPlans[this.state.main_selected_plan].paymentsWithDates[this.state.sub_selected_plan].period,
                        "mobile_number": this.state.mobile_number,
                        "national_id": this.state.national_id,
                        "down_payment": Number(this.state.down_payment),
                        "otp": this.state.otp,
                        "subtype": "SYMPL"
                    }, "shipping_data": {
                        'apartment': "",
                        'email': this.state.userData.order_email,
                        'floor': "",
                        'first_name': this.getFirstName(this.state.userData.order_full_name),
                        'street': "",
                        'building': "",
                        'phone_number': this.state.userData.order_phone,
                        'postal_code': "",
                        'city': "",
                        'country': "",
                        'last_name': this.getLastName(this.state.userData.order_full_name),
                        'state': "",
                        'extra_description': ''
                    },
                    "token": this.state.userData.token,
                    "integration_id": this.state.userData.integration_ids.SYMPL
                };
                if(this.state.promo_step == 3 && this.state.promo_state == "success"){
                    paymentDict["source"]["promo_code"] = this.state.promo_code
                }
                if(this.state.deliveryNeed){
                    paymentDict.shipping_data.country = this.state.deliveryData.country;
                    paymentDict.shipping_data.state = this.state.deliveryData.state;
                    paymentDict.shipping_data.city = this.state.deliveryData.city;
                    paymentDict.shipping_data.building = this.state.deliveryData.building;
                    paymentDict.shipping_data.street = this.state.deliveryData.street;
                    paymentDict.shipping_data.floor = this.state.deliveryData.floor;
                    paymentDict.shipping_data.apartment = this.state.deliveryData.apartment;
                    paymentDict.shipping_data.postal_code = this.state.deliveryData.postal_code;
                    paymentDict.shipping_data.extra_description = this.state.deliveryData.notes;
                }
            }else if(this.props.sourcePage ==='product'){
                paymentDict = {
                    "order_data": {
                        "delivery_needed": this.state.deliveryNeed,
                        "amount_cents": this.state.userData.amount * this.props.quantity * 100,
                        "currency": this.state.userData.currency,
                        "shipping_data": {
                            "first_name": this.getFirstName(this.state.deliveryData.name),
                            "last_name": this.getLastName(this.state.deliveryData.name),
                            "phone_number": this.state.deliveryData.phone,
                            "email": this.state.deliveryData.email,
                            "street": 'NA',
                            "city": 'NA',
                            "country": 'NA',
                            "postal_code": 'NA',
                            "state": "NA"
                        },
                        "items": [{
                            "name": this.state.userData.product.product_name,
                            "amount_cents": this.state.userData.amount * 100,
                            "quantity": this.props.quantity,
                        }]
                    },
                    "source": {
                        "identifier" : this.state.cardNumber,
                        "sourceholder_name" : this.state.cardHolderName,
                        "expiry_month" : this.state.expiryMonth,
                        "expiry_year" : this.state.expiryYear,
                        "cvn" : this.state.cvv,
                        "down_payment": this.state.down_payment,
                        "tenure": this.state.sympl_plans_data.paymentPlans[this.state.main_selected_plan].tenure.paymentsCount,
                        "selected_plan": this.state.sympl_plans_data.paymentPlans[this.state.main_selected_plan].paymentsWithDates[this.state.sub_selected_plan].period,
                        "mobile_number": this.state.phone_number,
                        "subtype": "SYMPL"
                    },
                    "token": this.state.userData.token,
                    "integration_id": this.state.userData.integrations.SYMPL,
                };
                if(this.state.deliveryNeed){
                    paymentDict.order_data.shipping_data.country = this.state.deliveryData.country;
                    paymentDict.order_data.shipping_data.state = this.state.deliveryData.state;
                    paymentDict.order_data.shipping_data.city = this.state.deliveryData.city;
                    paymentDict.order_data.shipping_data.building = this.state.deliveryData.building;
                    paymentDict.order_data.shipping_data.street = this.state.deliveryData.street;
                    paymentDict.order_data.shipping_data.floor = this.state.deliveryData.floor;
                    paymentDict.order_data.shipping_data.apartment = this.state.deliveryData.apartment;
                    paymentDict.order_data.shipping_data.postal_code = this.state.deliveryData.postal_code;
                    paymentDict.order_data.shipping_data.extra_description = this.state.deliveryData.notes;
                }
            }
            
            
            let jsonPaymentDict = JSON.stringify(paymentDict);
            let config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                }
            };
            axios.post(url, jsonPaymentDict, config)
            .then((resp) => {
                //enable payment methods
                this.props.enableAllPaymentMethods();
                //show result
                if(resp.data.success === true){
                    if (resp.data.url) {
                        window.location.href = resp.data.url;
                    }else {
                        //stop waiting
                        this.setState({waiting: false});
                        this.props.setReqComplete({head: 'Transaction successful', body:'Thank you for using the online payment service.'});
                        //this.props.setReqComplete({sympl: true, sympl_data: {}});
                    }
                }else{
                    //succes = false
                    this.props.setReqComplete({head: 'Transaction declined', body:'Please try again later. If this problem persists, please contact your service provider.'});
                }
            })
            .catch((err) => {
                //stop waiting
                this.setState({waiting: false});
                //enable payment methods
                this.props.enableAllPaymentMethods();
                if(err.response.status === 404){
                    alert('Please check your internet connection and try again.');
                }
            });

        })
    }
    resend_otp = (e) => {
        e.preventDefault();
        this.setState({step4_waiting: true}, ()=>{
            let url = appConfig.getServerUrl() + '/api/auth/bank-installments/sympl';
            let sympl_data = {
                "mobile_number": this.state.mobile_number,
                "national_id": this.state.national_id,
				"down_payment": Number(this.state.down_payment),
                "card_pin": this.state.last_sympl_card.card,
                "card_expiry": this.state.last_sympl_card.month + this.state.last_sympl_card.year,
                "payment_token": this.state.userData.sympl_payment_key,
                "request_otp": true
            }
            if(this.state.promo_step == 3 && this.state.promo_state == "success"){
                sympl_data["promo_code"] = this.state.promo_code
            }
            let json_sympl_data = JSON.stringify(sympl_data);
            let config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                }
            };
            axios.post(url, json_sympl_data, config)
            .then((resp) => {
                if(resp.data.httpStatus == 400){
                    this.setState({step4_waiting: false, step4_error: true})
                }else{
                    this.setState({step4_waiting: false, step4_error: false})
                }
            })
            .catch((err) => {
                this.setState({step4_waiting: false, step4_error: true})
            });
        })
    }
    render_otp_form = () => {
        return(
            <Form onSubmit={this.final_submit}>
                <div id="sypml_otp_div" className="verify_phone_div">
                    {this.state.step4_waiting ?
                        <div className="otp_waiting_div">
                            <i id="symple_waiting_icon" className="fa fa-spinner fa-spin"/>
                        </div>
                    :
                        <>
                            <h3>Verify your phone number</h3>
                            <p>Enter the verification code sent to <span id="otp_phone_number">{this.state.mobile_number}</span></p>
                            <div className="otp_input_div">
                                {/* <input type="text" id="otp_num_1" maxlength="1" onchange="handle_otp_input_change(1);" onkeyup="handle_otp_input_change(1);" /> */}
                                <Input type="text" autoFocus 
                                    value={this.state.otp}
                                    onChange={this.change_otp}
                                    name="otp"
                                    disabled={this.state.step4_waiting}
                                    validations={[required]} 
                                />
                            </div>
                            <div className="error_messages" id="otp_error_id"></div>
                            <div className="otp_edit_div">
                                <p>Didn't receive code? <span id="resend_otp_btn" onClick={this.resend_otp} >Resend</span> or <span id="back_to_step2" onClick={(e) => { this.setState({current_step: 2}) }}>Edit mobile no.</span></p>
                                <p>For assistance, call <span>15987</span></p>
                                <Button className="confirmBtnNew">PAY EGP {this.state.sympl_plans_data.customerTxnPayment.downPayment + this.state.sympl_plans_data.customerTxnPayment.fees} & proceed!</Button>
                            </div>
                        </>
                    }
                </div>
            </Form>
        )
    }
    render() {
        return (
            <div className="cardNew">
                {/* <h3>Add your card information to check if you have <b>SYMPL</b></h3> */}
                    <div className="sympl_container">
                        <img className="main_logo" src={symplImg} alt="sympl" />
                        <p className="sy_main_h">Pay later with 0% interest</p>
                    </div>
                    {this.state.waiting? 
                        <Waiting height='311px' />
                    :
                        <>
                            {this.state.current_step == 1 &&
                                this.render_card_form()
                            }
                            {this.state.current_step == 2 &&
                                this.render_phone_national_form()
                            }
                            {this.state.current_step >= 3 &&
                                this.render_sympl()
                            }
                             {this.state.current_step == 4 &&
                                this.render_otp_form()
                            }
                            <div className='text-center cardFooter'>
                                <span>
                                    <i className="fa fa-lock"></i>
                                    Secured by Paymob
                                </span>
                            </div>
                        </>
                    }
            </div>
        );
    }
}

export default card;
